import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DeliveryTypeSelectorComponent } from '../delivery-type-selector/delivery-type-selector.component';
import { IconComponent } from '@mode/capra';

@Component({
  standalone: true,
  imports: [CommonModule, IconComponent, DeliveryTypeSelectorComponent],
  selector: 'mode-delivery',
  templateUrl: './delivery.component.html',
  styleUrls: ['./delivery.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveryComponent {
  @Input() deliveryType = 'none';
  @Input() slackDeliveryOptionEnabled = false;
  @Output() deliveryTypeChanged = new EventEmitter<string>();
  public slackOptionDisabled = true;
}
